var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTypeFocus = function SvgIconTypeFocus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.286 7.143A6.857 6.857 0 0 1 7.143.286h13.714a6.857 6.857 0 0 1 6.857 6.857v13.714a6.857 6.857 0 0 1-6.857 6.857H7.143a6.857 6.857 0 0 1-6.857-6.857V7.143ZM7.143 2.57h13.714c.848 0 1.642.231 2.322.633l-5.75 5.751V6a1.143 1.143 0 0 0-2.286 0v5.714c0 .631.511 1.143 1.143 1.143H22a1.143 1.143 0 0 0 0-2.286h-2.955l5.75-5.75a4.55 4.55 0 0 1 .633 2.322v13.714a4.571 4.571 0 0 1-4.57 4.572H7.142a4.55 4.55 0 0 1-2.322-.633l5.75-5.751V22a1.143 1.143 0 1 0 2.286 0v-5.714c0-.632-.512-1.143-1.143-1.143H6a1.143 1.143 0 0 0 0 2.285h2.955l-5.75 5.751a4.55 4.55 0 0 1-.634-2.322V7.143A4.571 4.571 0 0 1 7.143 2.57Z",
    fill: "#73777A"
  })));
};
export default SvgIconTypeFocus;